export default __webpack_public_path__ + "static/media/Mobile_BG_main.258a8f1e.svg";